import axios from "axios";

// IMPORTANT: Always call the API on the SAME ORIGIN as the frontend.
// Both `*.preview.emergentagent.com` (preview) and the custom production
// domain (e.g. trackmatrix.net) forward `/api/*` to the backend, so a
// same-origin call works in every environment AND avoids all cross-origin
// CORS pain — including the broken `Allow-Origin: *` + `Allow-Credentials: true`
// header combo that strict browsers (Safari ITP, Firefox ETP, Brave) reject.
// process.env.REACT_APP_BACKEND_URL is only used as a fallback for SSR / test
// contexts where window is not available.
const ORIGIN =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${ORIGIN}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Credentials-free axios instance for PUBLIC endpoints that do NOT need auth.
// Some strict browsers (Safari ITP, Firefox ETP, Brave shields) block or
// strip cross-origin credentialed requests when triggered from a 3rd-party
// context (clicking a link from WhatsApp/Instagram/etc). Public endpoints
// like /api/r/{slug} and /api/referral/info/{code} should never carry cookies.
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e) return "";
        const field = Array.isArray(e.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
        const msg = typeof e.msg === "string" ? e.msg : JSON.stringify(e);
        return field ? `${field}: ${msg}` : msg;
      })
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
